import {
  FETCH_PRODUCT_STORE_REQUEST,
  FETCH_PRODUCT_STORE_SUCCESS,
  FETCH_PRODUCT_STORE_FAILURE,
  QUANTITY_CHANGE,
  FETCH_CNET_CONTENT_CHECK_REQUEST,
  FETCH_CNET_CONTENT_CHECK_UPDATE,
  UPDATE_SWATCH_MODAL_OPEN
} from '../../actionTypes/productStoreActionTypes'

const fetchProductStoreRequest = payload => ({
  type: FETCH_PRODUCT_STORE_REQUEST,
  payload
})

const fetchProductStoreSuccess = payload => ({
  type: FETCH_PRODUCT_STORE_SUCCESS,
  payload
})

const fetchProductStoreFailure = payload => ({
  type: FETCH_PRODUCT_STORE_FAILURE,
  payload
})

const updateQuantity = payload => ({
  type: QUANTITY_CHANGE,
  payload
})

const fetchCnetContentCheckRequest = payload => ({
  type: FETCH_CNET_CONTENT_CHECK_REQUEST,
  payload
})

const fetchCnetContentCheckUpdate = payload => ({
  type: FETCH_CNET_CONTENT_CHECK_UPDATE,
  payload
})

const updateSwatchModalOpen = payload => ({
  type: UPDATE_SWATCH_MODAL_OPEN,
  payload
})

export {
  fetchProductStoreRequest,
  fetchProductStoreSuccess,
  fetchProductStoreFailure,
  fetchCnetContentCheckRequest,
  fetchCnetContentCheckUpdate,
  updateQuantity,
  updateSwatchModalOpen
}
